<template>
  <v-dialog
    v-model="opened"
    max-width="310"
    persistent
    light
  >
    <v-card>
      <v-card-title class="headline">
        Export to Excel
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        This will export your search results into a excel file. <br>
        This file will be sended for your e-mail. <br><br>

        This may take a while...
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          small
          @click.native="close"
        >
          Annuler
        </v-btn>

        <v-btn
          color="info"
          small
          @click.native="exportToExcel"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useQuery } from '@vue/apollo-composable';

import { useStore } from 'vue2-helpers/vuex';
import { getGraphqlSchema } from '../../graphql/index';
import { EventBus } from '../../mixins';

// eslint-disable-next-line no-undef
const props = defineProps({
  dialog: {
    type: Boolean,
    default: false
  },
  close: {
    type: Function,
    required: true
  },
  allSearchVariables: {
    type: Object,
    required: true
  }
});

const opened = computed(() => {
  if (props.dialog) {
    return true;
  }
  return false;
});

const callQuery = ref(false);

const searchVariables = computed(() => {
  const filters = props.allSearchVariables.query.bool.filter;

  // Get wtype from query
  let wtype = null;
  filters.forEach(t => {
    if (t.terms && t.terms.wtype) {
      wtype = t.terms.wtype[0];
    }
  });
  return {
    input: { query: props.allSearchVariables.query },
    wtype: wtype
  };
});

const exportToExcel = () => {
  callQuery.value = true;
};

const store = useStore();

const { onResult, onError } = useQuery(
  getGraphqlSchema('exportExcel'),
  searchVariables,
  { enabled: callQuery, fetchPolicy: 'no-cache' }
);

onResult(r => {
  if (r.loading) {
    return;
  }
  
  // Cancel query after one execution
  callQuery.value = false;

  const options = {
    timeout: 5000,
    type: 'success'
  };

  const text = 'You will receive an email as soon as the extraction is completed.';

  EventBus.$emit('show-notification', { text, options });

  props.close();
});

onError(error => {
  const options = {
    timeout: 5000,
    type: 'error'
  };

  // Cancel query after one execution
  callQuery.value = false;

  const text = error.message;

  EventBus.$emit('show-notification', { text, options });

  props.close();
});

</script>

<style lang="scss" scoped>

</style>
